import * as React from "react";

import './App.css'
import {Link, Navigate, Outlet, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import rootStore from "./stores/rootStore.js";
import LoginPage from "./pages/public/LoginPage.jsx";
import RegisterPage from "./pages/public/RegisterPage.jsx";
import RegisterResellerPage from "./pages/public/RegisterResellerPage.jsx";
import ActivateResellerPage from "./pages/public/ActivateResellerPage.jsx";
import Layout from "./pages/Layout.jsx";
import ActivateUserPage from "./pages/public/ActivateUserPage.jsx";
import PublicLayout from "./components/publicLayout.jsx";
import CustomerDashboard from "./pages/protected/customer/CustomerDashboard.jsx";
import TaxAuthDashboard from "./pages/protected/taxauth/TaxAuthDashboard.jsx";
import AdminDashboard from "./pages/protected/admin/AdminDashboard.jsx";
import {observer} from "mobx-react";
import ResellerDashboard from "./pages/protected/reseller/ResllerDashboard.jsx";
import AdminOrdersPage from "./pages/protected/admin/AdminOrdersPage.jsx";
import AdminProductsPage from "./pages/protected/admin/AdminProductsPage.jsx";
import AdminOrderDetails from "./pages/protected/admin/AdminOrderDetails.jsx";
import AdminReportsPage from "./pages/protected/admin/AdminReportsPage.jsx";
import AdminReportsHomePage from "./pages/protected/admin/reports/AdminReportsHomePage.jsx";
import AdminRevenueReportPage from "./pages/protected/admin/reports/AdminRevenueReportPage.jsx";
import AdminOrdersByTaxAuthorityPage from "./pages/protected/admin/reports/AdminOrdersByTaxAuthorityPage.jsx";
import AdminOrdersByDatePage from "./pages/protected/admin/reports/AdminOrdersByDatePage.jsx";
import AdminOrdersByVendorPage from "./pages/protected/admin/reports/AdminOrdersByVendorPage.jsx";
import AdminPayoutsReportPage from "./pages/protected/admin/reports/AdminPayoutsReportPage.jsx";
import AdminOutageReportPage from "./pages/protected/admin/reports/AdminOutageReportPage.jsx";
import AdminProductDetailsPage from "./pages/protected/admin/AdminProductDetailsPage.jsx";
import InviteTaxAuthPage from "./pages/protected/admin/InviteTaxAuthPage.jsx";
import TaxAuthDetails from "./pages/protected/admin/TaxAuthDetails.jsx";
import TaxAuthAdminPage from "./pages/protected/admin/TaxAuthAdminPage.jsx";
import OnboardTaxAuthorityPage from "./pages/public/OnboardTaxAuthorityPage.jsx";
import TaxAuthBillingPage from "./pages/protected/taxauth/TaxAuthBillingPage.jsx";
import TaxAuthStripeCallbackPage from "./pages/protected/taxauth/TaxAuthStripeCallbackPage.jsx";
import TaxAuthOrdersPage from "./pages/protected/taxauth/TaxAuthOrdersPage.jsx";
import TaxAuthOrderDetails from "./pages/protected/taxauth/TaxAuthOrderDetails.jsx";
import ReportsPage from "./pages/protected/taxauth/ReportsPage.jsx";
import ForgotPasswordPage from "./pages/public/ForgotPasswordPage.jsx";
import ResetPasswordPage from "./pages/public/ResetPasswordPage.jsx";
import StatusPage from "./pages/public/StatusPage.jsx";
import NewOrderPage from "./pages/protected/customer/Order/NewOrderPage.jsx";
import {useEffect} from "react";
import PaymentMethodsPage from "./pages/protected/customer/PaymentMethods/PaymentMethodsPage.jsx";
import AcceptInvitePage from "./pages/public/AcceptInvitePage.jsx";
import OrderDetailsPage from "./pages/protected/customer/Order/OrderDetailsPage.jsx";
import CustomerOrdersPage from "./pages/protected/customer/CustomerOrdersPage.jsx";
import AccountPage from "./pages/protected/AccountPage.jsx";
import OutageAdminPage from "./pages/protected/taxauth/OutageAdminPage.jsx";
import ChangePasswordPage from "./pages/protected/ChangePasswordPage.jsx";
import TermsPage from "./pages/public/TermsPage.jsx";
import MonthlySalesSummaryReportPage from "./pages/protected/taxauth/MonthlySalesSummaryReportPage.jsx";
import SalesTransactionsReportPage from "./pages/protected/taxauth/SalesTransactionsReportPage.jsx";
import NonBillableOrdersReportPage from "./pages/protected/taxauth/NonBillableOrdersReportPage.jsx";
function App() {
    useEffect(() => {

    }, []);

    const authStore = rootStore.authenticationStore;
    return (
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={
                    <PublicLayout>
                        <RegisterPage />
                    </PublicLayout>} />
                <Route path="/registerReseller" element={
                    <PublicLayout>
                        <RegisterResellerPage />
                    </PublicLayout>} />
                <Route path="/reseller/activate/:activationKey" element={
                    <PublicLayout>
                        <ActivateResellerPage/>
                    </PublicLayout>} />
                <Route path="/invite/:activationKey" element={
                    <PublicLayout>
                        <AcceptInvitePage/>
                    </PublicLayout>} />
                <Route path="/terms" element={
                    <PublicLayout>
                        <TermsPage />
                    </PublicLayout>
                } />
                <Route path="/activate/:activationKey" element={
                    <PublicLayout>
                        <ActivateUserPage/>
                    </PublicLayout>} />
                <Route path="/taxauth/onboard/:inviteKey" element={
                    <PublicLayout>
                        <OnboardTaxAuthorityPage/>
                    </PublicLayout>
                } />
                <Route path="/forgotPassword" element={
                    <PublicLayout>
                        <ForgotPasswordPage/>
                    </PublicLayout>
                } />
                <Route path="/status" element={
                    <PublicLayout>
                        <StatusPage/>
                    </PublicLayout>
                } />
                <Route path="/resetPassword/:resetKey" element={
                    <PublicLayout>
                        <ResetPasswordPage/>
                    </PublicLayout>
                } />
                <Route element={<Layout />}>

                    <Route path="/admin/orders" element={
                            <RequireAuth>
                                <AdminOrdersPage />
                            </RequireAuth>
                        }
                    />
                    <Route path="/admin/orders/:orderId" element={
                            <RequireAuth>
                                <AdminOrderDetails />
                            </RequireAuth>
                        }
                    />
                    <Route path="/admin/inviteTaxAuth" element={
                            <RequireAuth>
                                <InviteTaxAuthPage />
                            </RequireAuth>
                        }
                    />
                    <Route path="/admin/taxAuths" element={
                            <RequireAuth>
                                <InviteTaxAuthPage />
                            </RequireAuth>
                        }
                    />
                    <Route path="/admin/taxAuths/:taxAuthId" element={
                            <RequireAuth>
                                <TaxAuthDetails />
                            </RequireAuth>
                        }
                    />
                    {
                        !authStore.signedIn() && (
                            <Route path="/" element={
                                    <LoginPage/>
                                }
                            />
                        )
                    }
                    {
                        authStore.signedIn() && (authStore.authentication.orgType === 'CustomerOrg' || authStore.authentication.orgType === '' ) && ! authStore.authentication.reseller && (
                            <Route path="/" element={
                                    <RequireAuth>
                                        <CustomerDashboard />
                                    </RequireAuth>
                                }
                            />
                        )
                    }
                    {
                        authStore.signedIn() && authStore.authentication.orgType === 'CustomerOrg' && authStore.authentication.reseller && (
                            <Route path="/" element={
                                    <RequireAuth>
                                        <ResellerDashboard />
                                    </RequireAuth>
                                }
                            />
                        )
                    }
                    {
                        authStore.signedIn() && authStore.authentication.orgType === 'TaxAuthority' && (
                            <Route path="/" element={
                                    <RequireAuth>
                                        <TaxAuthDashboard />
                                    </RequireAuth>
                                }
                            />
                        )
                    }
                    {
                        authStore.signedIn() && authStore.authentication.orgType === 'AdminOrg'  && (
                            <Route
                                path="/"
                                element={
                                    <RequireAuth roles={["SystemAdmin","SuperUser"]}>
                                        <AdminDashboard />
                                    </RequireAuth>
                                }
                            />
                        )
                    }
                    {/*Admin Routes*/}
                    <Route path="/admin/inviteTaxAuth" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <InviteTaxAuthPage/>
                        </RequireAuth>
                    )}/>
                    <Route path="/admin/order" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminOrdersPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/products" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminProductsPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/products/:productId" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminProductDetailsPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/reports" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminReportsHomePage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/reports/revenue" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminRevenueReportPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/reports/by-taxauthority" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminOrdersByTaxAuthorityPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/reports/by-date" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminOrdersByDatePage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/reports/by-vendor" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminOrdersByVendorPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/reports/payouts" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminPayoutsReportPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/reports/outages" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminOutageReportPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/order/:orderId" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <AdminOrderDetails/>
                        </RequireAuth>
                    )}/>
                    <Route path="/admin/taxAuth" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <TaxAuthAdminPage/>
                        </RequireAuth>
                    )}/>
                    <Route path="/admin/taxAuth/:taxAuthId" element={(
                        <RequireAuth roles={["SystemAdmin", "SuperUser"]}>
                            <TaxAuthDetails/>
                        </RequireAuth>
                    )}/>
                    {/*Customer Routes*/}
                    <Route path="/customer/orders" element={(
                        <RequireAuth roles={["Customer", "CustomerAdmin", "CustomerFinanceUser"]}>
                            <CustomerOrdersPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/order/new" element={(
                        <RequireAuth roles={["Customer", "CustomerAdmin", "CustomerFinanceUser"]}>
                            <NewOrderPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/order/:orderId" element={(
                        <RequireAuth roles={["Customer", "CustomerAdmin", "CustomerFinanceUser"]}>
                            <OrderDetailsPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/taxAuthority/order/:orderId" element={(
                        <RequireAuth roles={["MuniAdmin", "MuniFinanceUser", "MuniTechUser"]}>
                            <TaxAuthOrderDetails/>
                        </RequireAuth>
                    )} />
                    <Route path="/admin/paymentMethods" element={(
                        <RequireAuth roles={["Customer", "CustomerAdmin", "CustomerFinanceUser"]}>
                            <PaymentMethodsPage/>
                        </RequireAuth>
                    )} />
                    {/*Account Routes*/}
                    <Route path="/account" element={(
                        <RequireAuth>
                            <AccountPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/account/password" element={(
                        <RequireAuth blockExternalOnly>
                            <ChangePasswordPage/>
                        </RequireAuth>
                    )} />
                    {/*Tax Authority Routes*/}
                    <Route path="/taxauth/orders" caseSensitive={false} element={(
                        <RequireAuth roles={["MuniAdmin", "MuniFinanceUser", "MuniTechUser"]}>
                            <TaxAuthOrdersPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/taxAuth/reports" element={(
                        <RequireAuth roles={["MuniAdmin", "MuniFinanceUser", "MuniTechUser"]}>
                            <ReportsPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/taxAuth/reports/monthly-sales-summary" element={(
                        <RequireAuth roles={["MuniAdmin", "MuniFinanceUser", "MuniTechUser"]}>
                            <MonthlySalesSummaryReportPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/taxAuth/reports/sales-transactions" element={(
                        <RequireAuth roles={["MuniAdmin", "MuniFinanceUser", "MuniTechUser"]}>
                            <SalesTransactionsReportPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/taxAuth/reports/non-billable-orders" element={(
                        <RequireAuth roles={["MuniAdmin", "MuniFinanceUser", "MuniTechUser"]}>
                            <NonBillableOrdersReportPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/taxAuth/billing" element={(
                        <RequireAuth roles={["MuniAdmin", "MuniFinanceUser"]}>
                            <TaxAuthBillingPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/taxAuth/billing/stripeCallback" element={(
                        <RequireAuth roles={["MuniAdmin", "MuniFinanceUser"]}>
                            <TaxAuthStripeCallbackPage/>
                        </RequireAuth>
                    )} />
                    <Route path="/taxAuth/outage" element={(
                        <RequireAuth roles={["MuniAdmin", "MuniTechUser"]}>
                            <OutageAdminPage/>
                        </RequireAuth>
                    )} />


                </Route>
            </Routes>
    );
}

function RequireAuth({children, roles, blockExternalOnly}) {
    let location = useLocation();
    let authStore = rootStore.authenticationStore;
    if (!authStore.signedIn()) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (roles && roles.length){
        if (!roles.includes(authStore.authentication.role)){
            return <Navigate to="/login" state={{ from: location }} replace />;
        }
    }
    if (blockExternalOnly && authStore.authentication?.isExternalOnly) {
        return <Navigate to="/account" state={{ from: location }} replace />;
    }


    return children;
}

export default observer(App)
